import React, {useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import UiInputList from "../components/Form/UiInputList";
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputTextarea from "../components/Form/UiInputTextarea";
import UiGridFormTable from "../components/Form/UiGridFormTable";
import Overlay from "../components/Overlay";

const tipoList = [
    { id: 1, title: 'Nota de Serviço' },
    { id: 2, title: 'Nota de Produto' },
];

const toDefaults = (data: any) => {
    if (!data) {
        return { tipo: 1, situacao: 1, valorDesconto: 0, itens: [] };
    }
    return { itens: [], ...data };
};

export default function NotaFiscalForm(props: any) {
    const methods = useForm({
        defaultValues: toDefaults(props.data),
        shouldUnregister: false,
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        if (props.data) {
            reset(toDefaults(props.data));
        }
    }, [props.data, reset]);

    if (props.loading) {
        return <Overlay show={true} />;
    }

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    <fieldset>
                        <legend>Dados da Nota</legend>
                        <div className="row">
                            <UiInputSuggest size={6} router="emitente" idField="id" titleField="razao_social" name="emitente" label="Emitente"/>
                            <UiInputList size={3} name="tipo" list={tipoList} idField="id" titleField="title" label="Tipo" placeholder={false}/>
                            <UiInputText size={3} name="pessoaIdDestinatario" label="ID Destinatário" type="number"/>
                            <UiInputText size={3} name="serie" label="Série"/>
                            <UiInputText size={3} name="numero" label="Número"/>
                            <UiInputText size={3} name="valorDesconto" label="Desconto (R$)" type="number" min={0} step="any"/>
                            <UiInputText size={3} name="contratoId" label="ID Projeto" type="number"/>
                            <UiInputTextarea size={12} name="observacao" label="Observação" rows={2}/>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend>Itens</legend>
                        <div className="row">
                            <UiGridFormTable name="itens" label="Itens da Nota">
                                <UiInputText size={5} name="descricao" label="Descrição"/>
                                <UiInputText size={2} name="quantidade" label="Qtd" type="number" min={0} step="any"/>
                                <UiInputText size={3} name="valorUnitario" label="Valor Unit." type="number" min={0} step="any"/>
                                <UiInputText size={2} name="valorDesconto" label="Desconto" type="number" min={0} step="any"/>
                            </UiGridFormTable>
                        </div>
                    </fieldset>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    );
}
